import { WEBHOOK_TYPES } from "../../constants/strings";
import { ACTIONS } from "./webhook.actions";

export const initialState = {
  configuration: null,
  suspendedSecrets: null,
  loading: false,
  error: null,
};

const matchesWebhookType = (currentType, nextType) =>
  currentType === nextType ||
  (nextType === WEBHOOK_TYPES.NOTIFICATION && currentType == null);

const updateWebhookConfigurationRow = (configuration, nextConfigRow) => {
  if (!configuration || !Array.isArray(configuration.webhookConfiguration)) {
    return configuration;
  }

  const webhookConfiguration = configuration.webhookConfiguration;
  const rowExists = webhookConfiguration.some((row) =>
    matchesWebhookType(row.type, nextConfigRow.type)
  );

  return {
    ...configuration,
    webhookConfiguration: rowExists
      ? webhookConfiguration.map((row) =>
          matchesWebhookType(row.type, nextConfigRow.type) ? nextConfigRow : row
        )
      : [...webhookConfiguration, nextConfigRow],
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.FETCH_WEBHOOK_CONFIGURATION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.FETCH_WEBHOOK_CONFIGURATION.SUCCESS:
      return {
        ...state,
        configuration: action.payload,
        loading: false,
        error: null,
      };

    case ACTIONS.FETCH_WEBHOOK_CONFIGURATION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.GENERATE_WEBHOOK_SECRET.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.GENERATE_WEBHOOK_SECRET.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case ACTIONS.GENERATE_WEBHOOK_SECRET.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.REVOKE_WEBHOOK_SECRET.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.REVOKE_WEBHOOK_SECRET.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case ACTIONS.REVOKE_WEBHOOK_SECRET.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.UPDATE_WEBHOOK_CONFIGURATION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.UPDATE_WEBHOOK_CONFIGURATION.SUCCESS: {
      const payload = action.payload;
      const hasWebhookConfiguration =
        payload && Array.isArray(payload.webhookConfiguration);
      return {
        ...state,
        configuration: hasWebhookConfiguration ? payload : state.configuration,
        loading: false,
        error: null,
      };
    }

    case ACTIONS.UPDATE_WEBHOOK_CONFIGURATION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.FETCH_SUSPENDED_SECRETS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.FETCH_SUSPENDED_SECRETS.SUCCESS:
      return {
        ...state,
        suspendedSecrets: action.payload,
        loading: false,
        error: null,
      };

    case ACTIONS.FETCH_SUSPENDED_SECRETS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.REACTIVATE_WEBHOOK_SECRET.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ACTIONS.REACTIVATE_WEBHOOK_SECRET.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case ACTIONS.REACTIVATE_WEBHOOK_SECRET.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIONS.CLEAR_WEBHOOK_CONFIGURATION:
      return {
        ...state,
        configuration: null,
        suspendedSecrets: null,
        loading: false,
        error: null,
      };

    case ACTIONS.REMOVE_SUSPENDED_SECRET:
      const { secretId, type } = action.payload;
      const updatedSuspendedSecrets = state.suspendedSecrets.map((entry) => {
        if (entry.type === type) {
          return {
            ...entry,
            suspendedSecrets: entry.suspendedSecrets.filter(
              (secret) => secret.secretId !== secretId
            ),
          };
        }
        return entry;
      });

      return {
        ...state,
        suspendedSecrets: updatedSuspendedSecrets,
      };

    case ACTIONS.ADD_SUSPENDED_SECRET:
      const { secret: newSuspendedSecret, type: secretType } = action.payload;
      const currentSuspendedSecrets = state.suspendedSecrets || [];

      const existingEntryIndex = currentSuspendedSecrets.findIndex(
        (entry) => entry.type === secretType
      );

      let updatedSuspendedSecretsList;
      if (existingEntryIndex >= 0) {
        updatedSuspendedSecretsList = currentSuspendedSecrets.map(
          (entry, index) => {
            if (index === existingEntryIndex) {
              return {
                ...entry,
                suspendedSecrets: [
                  ...entry.suspendedSecrets,
                  newSuspendedSecret,
                ],
              };
            }
            return entry;
          }
        );
      } else {
        updatedSuspendedSecretsList = [
          ...currentSuspendedSecrets,
          {
            type: secretType,
            suspendedSecrets: [newSuspendedSecret],
          },
        ];
      }

      return {
        ...state,
        suspendedSecrets: updatedSuspendedSecretsList,
      };

    case ACTIONS.SET_WEBHOOK_CONFIGURATION_ROW:
      return {
        ...state,
        configuration: updateWebhookConfigurationRow(
          state.configuration,
          action.payload
        ),
      };

    default:
      return state;
  }
};
